<template>
  <PageSecondary>
    <template #title>Level Up at Profa</template>
    <h1 style="font-size: xx-large; font-weight: 900;">Super-Ego Level & Hardcore Papa</h1>
    <h5 style="font-size: small; font-weight: normal;">
      <span>Вечер четверга, 4 марта, 18:45—21:45</span>
      <br>
      <a href="https://yandex.ru/maps/geo/metro_profsoyuznaya/100078796" target="_blank">м. Профсоюзная</a>
      <!--<span style="margin: auto 8px;">&#45;&#45;</span>-->
      <br>
      <span>Бесплатно</span>
    </h5>
    <div v-if="secret==='0ly7fhs2o'" style="display: flex; margin-bottom: 16px;">
      <i class="material-icons" style="margin: 0 8px 0 0;">location_on</i>
      <div>
        <a href="https://yandex.ru/maps/-/CCUQiPdEtB" target="_blank">Улица Профсоюзная 17к3, подъезд 2</a>
        <br>
        Код домофона 28к2430<br>
        Этаж 5, Квартира 28, Дверь открыта
      </div>
    </div>
    <img src="@/assets/superman_and_2_badmans.jpg" style="max-width: 100%; padding: 8px 0 0; box-sizing: border-box;">
    <div style="font-style: italic; color: gray; font-size: small; margin-bottom: 16px;">
      Super-Ego держит капризного ребенка и скоро ввалит жестокому внутреннему родителю.
    </div>
    Для кого, с кем и как? На встрече собираются:
    <ul style="">
      <li>Приятные, честные, открытые люди.</li>
      <li>Те, кто активно растёт как личность.</li>
      <li>Мы практикуем осознанный контакт между участниками.</li>
      <li>Пьём горячий чай, сидим в пледах, залипаем на свечи, и делимся плюшками.</li>
    </ul>
    <img src="@/assets/father_and_kid_sea.jpg" style="max-width: 100%; padding: 8px 0 0; box-sizing: border-box;">
    <div style="font-style: italic; color: gray; font-size: small; margin-bottom: 16px;">
      Внутренний отец помогает исследовать новое.
    </div>
    На встрече будут:
    <ul style="">
      <li>Теория эволюции сознания, расскажу и обсудим.</li>
      <li>Групповой тренинг.</li>
      <li>Два суровых упражененя на контакт с внутренним образом отца, участники получат обязательное домашнее задание.
      </li>
      <li>Закончим заряжающей визуализацией.</li>
    </ul>
    <img src="@/assets/gd1.gif" style="max-width: 100%;">
    <div style="font-style: italic; margin-bottom: 256px;">
      * Встреча на 8 участников, осталось 4 места. Напиши мне, чтобы участвовать и узнать адрес.<br>
      ** Поужинать до встречи и взять с собой перекус к чаю.
    </div>
  </PageSecondary>
</template>

<script>
import PageSecondary from "@/components/PageSecondary";

export default {
  name: 'LevelUpAtProfa_2021_03_04',
  components: {PageSecondary},
  props: {
    secret: String,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
